<template>
  <div class="plc-search-wrap">
    <div class="search-left">
      <el-input
        class="plc-input"
        placeholder="商品名称，型号模糊检索"
        v-model="dataForm.skuNameOrModel"
        style="width: 406px"
        clearable
        @keyup.enter.native="doSearch"
        @clear="doSearch"
      >
        <i slot="prefix" class="plc-search"></i>
      </el-input>
      <el-input
        placeholder="商品编码"
        v-model="dataForm.plcSkuCode"
        style="width: 247px"
        class="plc-input mgl-20"
        clearable
        @keyup.enter.native="doSearch"
        @clear="doSearch"
      >
        <i slot="prefix" class="plc-search"></i>
      </el-input>
      <el-button
        style="margin-left: 12px"
        class="plc-btn"
        size="small"
        type="primary"
        @click="doSearch"
        >查询</el-button
      >
      <el-button class="plc-btn" @click="reset" size="small">重置</el-button>
    </div>
    <div class="search-right">
      <div
        class="list-icon"
        @click="changeType('list')"
        :class="{ active: type === 'list' }"
      >
        <i></i>
        <span>列表</span>
      </div>
      <div
        class="img-icon"
        @click="changeType('img')"
        :class="{ active: type === 'img' }"
      >
        <i></i>
        <span>大图</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'img'
    }
  },
  data () {
    return {
      dataForm: {
        skuNameOrModel: '',
        plcSkuCode: ''
      }
    }
  },
  methods: {
    changeType (t) {
      this.$emit('changeType', t)
    },
    doSearch () {
      this.$emit('doSearch')
    },
    reset () {
      this.dataForm = {
        skuNameOrModel: '',
        plcSkuCode: ''
      }
      this.$emit('reset')
    }
  }
}
</script>

<style lang="scss" scoped>
.mgl-20 {
  margin-left: 20px;
}

.plc-search {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: url(~@/assets/img/plc/search.png) no-repeat;
  background-size: cover;
  margin-top: 16px;
  margin-left: 12px;
}

.plc-search-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13.5px 24px 13.5px 6px;
  border-bottom: 1px solid #eeeeee;
}

.search-left {
  flex: 1;
}

.search-right {
  display: flex;
  align-items: center;
  color: #696969;
  font-size: 14px;
  > div {
    display: flex;
    align-items: center;
    margin-left: 24px;
    cursor: pointer;
    &:hover,
    &.active {
      color: #2a54d1;
    }
    i {
      display: inline-block;
      width: 21px;
      height: 20px;
      margin-right: 8px;
    }
  }
  .list-icon {
    i {
      background: url(~@/assets/img/plc/rq.png) no-repeat;
      background-size: cover;
    }
    &.active i,
    &:hover i {
      background: url(~@/assets/img/plc/rq-a.png) no-repeat;
      background-size: cover;
    }
  }
  .img-icon {
    i {
      background: url(~@/assets/img/plc/img.png) no-repeat;
      background-size: cover;
    }
    &.active i,
    &:hover i {
      background: url(~@/assets/img/plc/img-a.png) no-repeat;
      background-size: cover;
    }
  }
}
</style>
